import { useContext, useEffect, useState } from "react";

import TableCell from "../../../Components/Table/TableCell";
import TableContainer from "../../../Components/Table/TableContainer";
import TableHeader from "../../../Components/Table/TableHeader";
import TableSkeleton from '../../../Components/Table/TableSkeleton';
import { HttpContext } from "../../../HttpContext";

import styles from "./object.list.module.css";

export default function ObjectList() {
  const { httpClient } = useContext(HttpContext);
  const [objects, setObjects] = useState([
    {
      id: 1,
      kad: "22:63:010417:21",
      type: "Земельный участок",
      address: "г Барнаул, ул Сергея Семенова, д 18",
      area: 4447,
      description: "Дружный 3",
      date: "11.06.2021 10:40"
    }
  ]);

  useEffect(()=>{
    getObjects()
  },[])

  async function getObjects() {
    const response = await httpClient.get("/object/all")
    setObjects(response.data.Data)
  }

  return (
    <div className={styles.container}>
      <TableContainer>
        <TableHeader>
          <TableCell th="Кадастровый номер"/>
          <TableCell th="Вид объекта"/>
          <TableCell th="Адрес"/>
          <TableCell th="Площадь" />
          <TableCell th="Описание" />
          <TableCell th="Дата создания" />
        </TableHeader>
        <tbody className={styles.tbody}>
          {objects.map((x) =>
            <tr className={styles.tr} key={x.id}>
              <TableCell title={x.CadNumZu}/>
              <TableCell title={x.type}/>
              <TableCell title={x.address}/>
              <TableCell title={x.area}/>
              <TableCell title={x.description}/>
              <TableCell title={x.date}/>
            </tr>
          )}
          {objects.length === 0 &&
            <TableSkeleton row={6} col={5}/>
          }
        </tbody>
      </TableContainer>
    </div>
  )
}